import { Field, Modal, ActionButton, TextField } from 'components/commons';
import { useApi, useForm, useModal } from 'hooks';
import React, { useMemo } from 'react';
import { initialState as formState } from './customer-account-form.state';
import styles from './customer-account.module.scss';
import { NotifModal } from 'components/modals';
import { Grid } from '@material-ui/core';
import locale from 'localization';
import { useEffect } from 'react';
import { CarWithLady } from 'images';
import { handleRequest, parseNumber } from 'utils';
import { createCustomerAccount, updateCustomer } from 'apis/customer.api';
import SelectProduct from 'components/field/select-product/select-product';

import { InputAmount, SelectAccount } from 'components/field';

const CustomerAccountForm = ({ initialState, actionText, create, customerId, firstName, lastName, refreshPage, ...state }) => {
  const { close } = state;
  const notifModal = useModal();
  const form = useMemo(() => {
    return formState(initialState);
  }, [initialState]);

  const { fields, modifyField, submitForm, getFormValues, validateField, clearForm, isFormSubmittable, applyFieldErrors } =
    useForm({
      initialState: form
    });

  useEffect(() => {
    if (state.active) {
      clearForm();
    }
    //eslint-disable-next-line
  }, [state.active]);

  const addCustomerRequest = useApi({
    api: createCustomerAccount,
    handleOwnError: {
      badrequest: true
    }
  });

  const editCustomerRequest = useApi({
    api: updateCustomer,
    handleOwnError: {
      badrequest: true
    },
    params: {
      customerId
    }
  });

  const loading = addCustomerRequest.loading || editCustomerRequest.loading;

  const submit = async () => {
    const params = getFormValues();

    if (params.committedAmount) {
      params.committedAmount = parseNumber(params.committedAmount);
    }

    if (params.initialAmount) {
      params.initialAmount = parseNumber(params.initialAmount);
    } else {
      delete params.initialAmount;
    }

    const apiRequest = create ? addCustomerRequest : editCustomerRequest;

    if (create) {
      params.customerId = customerId;
      delete params.accountId;
    }

    handleRequest(
      async () => {
        const finalParams = {
          ...params
        };

        if (finalParams.committedAmount === '') {
          delete finalParams.committedAmount;
        }
        await apiRequest.request(finalParams, () => submit());

        close();

        refreshPage();

        notifModal.show({
          image: CarWithLady,
          title: create ? locale.customerAccountSuccessCreated : locale.customerAccountSuccessEdited,
          contentHighlight: [<b>{firstName}</b>, <b>{lastName}</b>],
          content: create ? 'You have successfully created customer account' : locale.successfullyChangeInfoOfCustomerName
        });
      },
      {
        CA0004: () => {
          applyFieldErrors({
            cifNumber: 'Customer account already exist'
          });
        }
      }
    );
  };

  return (
    <div>
      <NotifModal {...notifModal} />
      <Modal close={loading ? false : close} {...state} className={styles.modalContent}>
        <div className={styles.formContent}>
          <div className={styles.content}>
            <Grid container direction="row" spacing={2}>
              <Grid item xs={12} sm={10}>
                <Field {...fields.cifNumber}>
                  <TextField {...fields.cifNumber} onChange={modifyField} onBlur={validateField} />
                </Field>
              </Grid>
            </Grid>
            <Grid container direction="row" spacing={2}>
              <Grid item xs={12} sm={10}>
                <Field className={styles.status} label="Product">
                  <SelectProduct {...fields.productId} onChange={modifyField} />
                </Field>
              </Grid>
            </Grid>

            {['shared capital'].some((term) => fields?.productId?.label?.toString().toLowerCase().includes(term)) && (
              <div>
                <Grid container direction="row" spacing={2}>
                  <Grid item xs={12} sm={5}>
                    <Field className={styles.status} label="Committed Amount">
                      <InputAmount {...fields.committedAmount} onChange={modifyField} />
                    </Field>
                  </Grid>
                  <Grid item xs={12} sm={5}>
                    <Field className={styles.status} label="Initial Amount">
                      <InputAmount {...fields.initialAmount} onChange={modifyField} />
                    </Field>
                  </Grid>
                </Grid>

                <Grid container direction="row" spacing={2}>
                  <Grid item xs={12} sm={10}>
                    <Field {...fields.accountId} label="Account">
                      <SelectAccount {...fields.accountId} onChange={modifyField} />
                    </Field>
                  </Grid>
                </Grid>

                <Grid container direction="row" spacing={2}>
                  <Grid item xs={12} sm={10}>
                    <Field {...fields.orNumber} label="OR Number">
                      <TextField {...fields.orNumber} onChange={modifyField} onBlur={validateField} />
                    </Field>
                  </Grid>
                </Grid>
              </div>
            )}
          </div>
        </div>

        <ActionButton
          right
          items={[
            {
              onClick: () => {
                state.close();
              },
              disabled: loading,
              text: locale.cancel
            },
            {
              onClick: () => {
                submitForm(submit);
              },
              disabled:
                !isFormSubmittable ||
                (fields?.productId?.label?.toString().includes('Shared Capital')
                  ? !fields.committedAmount.value &&
                    !fields.initialAmount.value &&
                    !fields.orNumber.value &&
                    !fields.accountId.value
                  : false),
              loading,
              text: actionText
            }
          ]}
        />
      </Modal>
    </div>
  );
};

export default CustomerAccountForm;
